import type { AwsPartnerUserDetails } from './reducer'

export type PartnerCentralDetailForApi = {
  email: string
  first_name: string
  last_name: string
}

type PartnerUserNameFields = {
  email?: string | null
  firstName?: string | null
  lastName?: string | null
  first_name?: string | null
  last_name?: string | null
  username?: string | null
}

const toTrimmedString = (value: unknown) => String(value ?? '').trim()

/** Blank form row shown when a sync config has no Partner Central users yet. */
export const getEmptyAwsPartnerUserDetails = (): AwsPartnerUserDetails => ({
  id: `${Math.floor(Math.random() * 10000)}`,
  firstName: '',
  lastName: '',
  email: '',
})

export const isBlankAwsPartnerUser = (
  user?: PartnerUserNameFields | null
): boolean =>
  !toTrimmedString(user?.email) &&
  !toTrimmedString(user?.firstName ?? user?.first_name) &&
  !toTrimmedString(user?.lastName ?? user?.last_name)

export const mapPartnerCentralDetailsToFormUsers = (
  partnerCentralDetails: ReadonlyArray<PartnerUserNameFields> | null | undefined
): AwsPartnerUserDetails[] => {
  if (
    !Array.isArray(partnerCentralDetails) ||
    partnerCentralDetails.length === 0
  ) {
    return [getEmptyAwsPartnerUserDetails()]
  }

  return partnerCentralDetails.map((user, index) => ({
    id: `${index}-${user.username || Math.random().toString(36).substring(2, 10)}`,
    email: user.email || '',
    firstName: user.firstName || user.first_name || '',
    lastName: user.lastName || user.last_name || '',
  }))
}

/** Drops display-only placeholder rows so they are not persisted. */
export const mapUserDetailsToPartnerCentralDetailsForApi = (
  userDetails: ReadonlyArray<PartnerUserNameFields> | null | undefined
): PartnerCentralDetailForApi[] =>
  (userDetails ?? [])
    .filter(user => !isBlankAwsPartnerUser(user))
    .map(user => ({
      email: user.email ?? '',
      first_name: user.firstName ?? user.first_name ?? '',
      last_name: user.lastName ?? user.last_name ?? '',
    }))
